exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mb15[data-v-10795fc5]{\n  margin-bottom:15px;\n}\n.form-text_textarea_text01[data-v-10795fc5]{\n  width:100%;\n}\n", ""]);

// exports
